import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  loaderService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
import controller from './recommendation-report.controller';
import directive from './recommendation-report.directive';


export default angular.module('app.components.advisory.auditTrail.recommendationReport', [
  alerts,
  amDataService,
  confirmDialog,
  constants,
  loaderService,
  ssDialogService,
  userService,
])
  .directive('amRecommendationReport', directive)
  .controller('RecommendationReportController', controller)
  .name;

console.log('app.components.advisory.auditTrail.recommendationReport created');
